import classNames from "classnames";
import { useState } from "react";

import { ILayoutType } from "../../../utils/constants/routes";
import Footer from "../../base/Footer";
import Header from "../../base/Header";
import SideMenu from "../../base/SideMenu";
import AuthLayout from "../Auth";
import MainLayout from "../Main";
import SearchLayout from "../Search";

import styles from "./index.module.scss";

const LAYOUTS_BY_TYPE: Record<
  ILayoutType,
  React.FC<React.PropsWithChildren>
> = {
  auth: AuthLayout,
  main: MainLayout,
  search: SearchLayout,
};

interface IRootLayoutProps {
  type: ILayoutType;
  showHeader?: boolean;
  showFooter?: boolean;
}

function RootLayout({
  type,
  showHeader,
  showFooter,
  children,
}: React.PropsWithChildren<IRootLayoutProps>) {
  const [isMenuVisible, setIsMenuVissible] = useState(false);

  const handleMenuToggle = (isVisible: boolean) => () => {
    setIsMenuVissible(isVisible);
  };

  const Layout = LAYOUTS_BY_TYPE[type];

  return (
    <div>
      {showHeader && (
        <>
          <Header
            isMenuVisible={isMenuVisible}
            onMenuToggle={handleMenuToggle(!isMenuVisible)}
          />

          <SideMenu
            isVisible={isMenuVisible}
            onClose={handleMenuToggle(false)}
          />
        </>
      )}

      <main
        className={classNames(styles.container, {
          [styles.container_withHeader]: showHeader,
          [styles.container_withFooter]: showFooter,
        })}>
        <div className={styles.content}>
          <Layout>{children}</Layout>
        </div>
      </main>

      {showFooter && <Footer />}
    </div>
  );
}

export default RootLayout;
